export default __webpack_public_path__ + "static/media/1810.2fc06b6a.png";